import React, { useState } from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../shadcn/components/ui/button";

interface NameMismatchModalProps {
  open: boolean;
  setOpen: any;
  handleProfileUpdate: any;
  handleRetryKycRequest: () => void;
  profileName: string;
  kycName: string;
  userCanUpdate: boolean;
}

export default function NameMismatchModal({
  open,
  setOpen,
  profileName,
  userCanUpdate,
  kycName,
  handleProfileUpdate,
  handleRetryKycRequest,
}: NameMismatchModalProps) {
  return (
    <CustomModalLayout
      open={open}
      onClose={() => {
        // if (userCanUpdate) {
        // alert("Please update your profile before proceeding.");
        // } else {
        //   setOpen(false);
        // }
        setOpen(false);
      }}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[380px]">
        <div className="flex flex-col gap-3">
          <div className="font-semibold text-lg text-brand-textBlack text-center">
            Name Mismatch Detected
          </div>
          <div className="text-xs text-brand-textGrey text-center">
            Your profile name does not match the name on your official documents
            submitted for the auction participation request.
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-lg font-semibold text-brand-textBlack">
              Profile Name
            </div>
            <div className="text-lg font-semibold text-brand-orange">
              {profileName}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-lg font-semibold text-brand-textBlack">
              Name As per Document
            </div>
            <div className="text-lg font-semibold text-green-600">
              {kycName}
            </div>
          </div>
        </div>
        {/* {userCanUpdate ? (
          <Button
            className=""
            onClick={async () => {
              await handleProfileUpdate(kycName);
            }}
          >
            Save Profile and Retry KYC
          </Button>
        ) : ( */}
        <div>
          <div className="font-openSans text-xs text-center mb-3">
            Your profile name has been verified through PAN and cannot be
            updated directly. However, we have detected a mismatch between your
            profile name and your documents. Please contact Auction Bazaar
            support to request a correction.
          </div>
          <div className="font-openSans text-xs text-center">
            If you’ve uploaded the wrong document by mistake, please discard
            your current auction participation request and submit a new one with
            the correct documents.
          </div>
          <div
            onClick={handleRetryKycRequest}
            className="flex justify-center text-[#1C64F2] underline cursor-pointer font-medium text-xs mt-4"
          >
            Discard Application and Start Over
          </div>
        </div>
        {/* )} */}
      </div>
    </CustomModalLayout>
  );
}
